
<template>
    <Teleport to="body">
        <transition name="fade">
            <div v-show="showGuestsSearch" @click="closeguestsSearch" ref="guestsBG" id="guestsBG"
                @keydown.esc="closeGuestsSearch"
                class="bg-gray-200 bg-opacity-80 dark:bg-neutral-900 dark:bg-opacity-75 backdrop-blur-lg z-50 fixed top-0 left-0 h-full w-full py-8 pt-4 overflow-y-scroll overflow-x-hidden scrollbar-hide animate-in fade-in ease-in-out duration-800 big_guests js_close_clickable">
                <div class="w-full px-4 md:px-8 flex justify-between  js_close_clickable pb-4">
                    <button type="button" @click="switchToCalendar"
                        class="text-gray-500 my-5 group font-medium text-sm px-4 rounded-full duration-500 ease-in-out py-2.5 mr-auto mr-auto sm:ml-0 text-center inline-flex items-center transition cursor-pointer hover:bg-white">
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 mr-2" fill="currentColor"
                            viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                            <path
                                d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
                        </svg>
                        {{ $t('Select Dates') }}
                    </button>
                </div>
                <div class="px-4 md:px-8 js_close_clickable">
                    <div
                        class="bg-white p-8 max-w-xl mx-auto rounded-md w-full border-gray-300 animate-in slide-in-from-left fade-in ease-in-out duration-300 shadow-2xl ">

                        <div class="booking_spec_input_box flex flex-col divide-solid divide-y md:divide-y-0"
                            id="booking_spec_input_box">
                            <div class="input_field flex flex-col md:flex-row gap-2 md:gap-0 items-center pb-8 md:pb-4">
                                <div class="value">
                                    <span class="head">{{ $t('Adults') }}</span>
                                </div>
                                <div class="input_controls">
                                    <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_min  w-14 h-14"
                                        :class="numAdult == 1 ? 'disable' : ''" @click="decrementAdult()">
                                        -
                                    </div>
                                    <label for="NumtempAdult" class="hide">NumAdult:</label>
                                    <input id="NumtempAdult" name="NumtempAdult" type="number" min="0"
                                        class="w-[100px] max-w-[30vw] text-xl" v-bind:value="numAdult" />
                                    <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_plus w-14 h-14"
                                        @click="incrementAdult()">
                                        +
                                    </div>
                                </div>
                            </div>
                            <div class="input_field flex flex-col md:flex-row gap-2 md:gap-0 items-center pt-8 md:pt-4">
                                <div class="value flex flex-col items-center md:items-start">
                                    <span class="head">{{ $t('Children') }}</span>
                                    <span class="descr">{{ $t('3 - 17 years') }}</span>
                                </div>
                                <div class="input_controls">
                                    <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_min  w-14 h-14"
                                        :class="numChildren == 0 ? 'disable' : ''" @click="decrementChildren()">
                                        -
                                    </div>
                                    <label for="NumtempChild" class="hide">NumChild:</label>
                                    <input id="NumtempChild" name="NumtempChild" type="number" min="0"
                                        class="w-[100px] max-w-[30vw] text-xl" v-bind:value="numChildren" />
                                    <div class="btn btn-outline-secondary rounded-pill js_input_field_alter js_input_plus  w-14 h-14"
                                        @click="incrementChildren()">
                                        +
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button @click="performSearch"
                            class="bg-primary w-full mt-8 rounded-full p-4 flex justify-center items-center text-white transition duration-300 hover:scale-95 active:scale-75 active:bg-primary-dark">
                            {{ $t('Search') }}
                        </button>
                    </div>
                </div>
            </div>
        </transition>
    </Teleport>
</template>

<script>
const { debounce } = require("lodash");
import Helpers from "../../helpers";
import moment from "moment";
import VueCookies from 'vue-cookies';

export default {
    props: {
        lastDateAvailable: {
            type: [Number, Date],
            default: Infinity,
        },
        location: ''
    },
    mounted() {
        this.$root.$on("showGuestsSearch", (msg) => {
            $("body").addClass("scroll_lock")
            this.$refs.guestsBG.focus();
            this.showGuestsSearch = msg;
        });
    },
    data() {
        return {
            showGuestsSearch: false,
            numAdult: 1,
            numChildren: 0,
            numAdultTemp: null,
            numChildrenTemp: null,
        };
    },
    methods: {
        incrementAdult() {
            this.numAdult++;
            VueCookies.set('numAdult', this.numAdult);
            this.$root.$emit("numAdult", this.numAdult);
        },
        decrementAdult() {
            if (this.numAdult > 1) {
                this.numAdult--;
                VueCookies.set('numAdult', this.numAdult);
                this.$root.$emit("numAdult", this.numAdult);
            }
        },
        incrementChildren() {
            this.numChildren++;
            VueCookies.set('numChildren', this.numChildren);
            this.$root.$emit("numChildren", this.numChildren);
        },
        decrementChildren() {
            if (this.numChildren >= 1) {
                this.numChildren--;
                VueCookies.set('numChildren', this.numChildren);
                this.$root.$emit("numChildren", this.numChildren);
            }
        },
        closeguestsSearch(e) {
            if (e.target.classList.contains('js_close_clickable') || e.key == "Escape") {
                this.showGuestsSearch = false;
                setTimeout(function () {
                    $("body").removeClass("scroll_lock")
                }, 350);
            }
        },
        switchToCalendar() {
            this.showGuestsSearch = false
            this.$root.$emit("showCalendarSearch", true);
        },
        performSearch() {
            var url = this.$homeUrl + '/accomodations/?numAdult=' + parseInt(VueCookies.get('numAdult')) + '&numChildren=' + parseInt(VueCookies.get('numChildren'));

            if (VueCookies.get('checkin')) {
                url = url + '&checkin=' + moment(VueCookies.get('checkin')).format('YYYYMMDD')
            }
            if (VueCookies.get('checkout')) {
                url = url + '&checkout=' + moment(VueCookies.get('checkout')).format('YYYYMMDD')
            }
            if (VueCookies.get('searchlocation')) {
                var location = VueCookies.get('searchlocation');
                if (location.hasOwnProperty('nonHome')) {
                    url = url + '&' + encodeURIComponent(location.nonHome) + '=' + encodeURIComponent(location.name);
                } else {
                    url = url + '&name=' + encodeURIComponent(location.name);
                }
            }

            window.location.href = url;
        }
    },
    created() {
        if (VueCookies.get('numAdult')) {
            this.numAdult = parseInt(VueCookies.get('numAdult'))
        } else {
            this.numAdult = 2;
            VueCookies.set('numAdult', 2);
        }
        if (VueCookies.get('numChildren')) {
            this.numChild = parseInt(VueCookies.get('numChildren'))
        } else {
            this.numChildren = 0;
            VueCookies.set('numChildren', 0);
        }
        this.$root.$emit("numAdult", this.numAdult);
        this.$root.$emit("numChildren", this.numChildren);
    },
}
</script>